import { Component, Inject, Input} from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-alert-bar-invalid',
  templateUrl: './alert-bar-invalid.component.html',
  styleUrls: ['./alert-bar-invalid.component.scss']
})
export class AlertBarInvalidComponent{



  constructor(private _snackBar: MatSnackBar, @Inject(MAT_SNACK_BAR_DATA) public data: string) { }

  

  closeSnackBar(){
    this._snackBar.dismiss()
  }

}
